export default function GtSpinner(): JSX.Element {
  return (
    <div
      className="gt-spinnerIcon"
      style={{ backgroundImage: "url(/resources/gt-spinner.svg)" }}
    ></div>
  );
}
